module.exports = __webpack_public_path__ + "media/audio2.dcbc2085.mp3";